/* eslint-disable */
/*
 * A single field from a lexical entry.
 */

import React, { Component } from 'react'
import '../../stylesheets/lexicon.css'

/*
 * Props:
 *
 * lexentry - The lexical entry object that this field belongs to. Keys:
 *            lexentry_uuid, lexicon_uuid, graphemes, phonemes, soundslike, unigram, prob, solprobs
 *
 * field - Which field, e.g. 'graphemes', 'phonemes'.
 *
 * validateRe - A regular expression indicating if the entry is valid, which must match the entire
 *              string. 
 *
 * updateField - Called when the field gets updated. Passed the lexentry, the field ("grapheme", "phoneme", etc),
 *               the new value, and a boolean indicating if the database should be updated.
 *
 * tooltip - Displayed on hovering over the field.
 */

class LexentryField extends Component {
  render() {
    let value = this.props.lexentry[this.props.field] || ''
    let validateRe = this.props.validateRe || '.*'
    let tooltip = this.props.tooltip || 'Enter value'

    return (
      <td>
	<input type="text" className="lexentry" spellCheck="false"
	       value={value} pattern={validateRe} title={tooltip}
	       onChange={evt => {
		   this.props.updateField(this.props.lexentry, this.props.field, evt.target.value, false)
	       } }
	       onBlur={evt => {
		   this.props.updateField(this.props.lexentry, this.props.field, evt.target.value, evt.target.checkValidity());
	       }}
	       onKeyPress={evt => {
		   if (evt.key === 'Enter') {
		     evt.preventDefault();
		     evt.stopPropagation();
		     evt.target.blur();
		   }
	       }}
	/>
      </td>
    )
  }
}

export default LexentryField

